import React, {Component} from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {inject} from "mobx-react"; // This only needs to be imported once in your app

@inject(stores => ({
        token: stores.rootStore.Authorization.token,
    })
)

class PhotoSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            photoIndex: 0,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.photoIndex) {
            return {
                photoIndex: props.photoIndex
            }
        }
        return null;
    }

    render() {
        const {photoIndex} = this.state;
        const images = this.props.images;

        return (
            <div>
                <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => {
                        this.props.openPreview(false)
                    }}
                    onMovePrevRequest={() => {
                        const newIndex = (photoIndex + images.length - 1) % images.length;
                        this.setState({
                            photoIndex: newIndex,
                        });
                        this.props.openPreview(true, newIndex)
                    }
                    }
                    onMoveNextRequest={() => {
                        const newIndex = (photoIndex + 1) % images.length;
                        this.setState({
                            photoIndex: newIndex,
                        });
                        this.props.openPreview(true, newIndex);
                    }
                    }
                />
            </div>
        );
    }
}

export default PhotoSlider;